export default __webpack_public_path__ + "static/media/insights-preview.e962257e.png";